import { useMemo } from 'react';
import { Operation, Partner } from 'types';

type UseGetDividendDataForPartnerProps = {
  dividendOperation: Operation | undefined;
  partner: Partner;
};

const extractNewDividendData = (operation: Operation, partner: Partner) => {
  const dividend = partner.dividends?.find(
    (d) => d.operation === operation?._id
  );

  const retentionPercentage = dividend?.retentionPercentage || 0;

  return {
    ndPercentage: dividend?.ndPercentage ?? 0,
    retentionPercentage,
    amount: dividend?.amount ?? 0,
    retentionAmount: dividend?.retentionAmount ?? 0,
  };
};

export const useGetDividendDataForPartner = ({
  dividendOperation,
  partner,
}: UseGetDividendDataForPartnerProps) => {
  const data = useMemo(() => {
    if (!dividendOperation) {
      return {
        ndPercentage: 0,
        retentionPercentage: 0,
        amount: 0,
        retentionAmount: 0,
      };
    }

    return extractNewDividendData(dividendOperation, partner);
  }, [dividendOperation, partner]);

  return { data };
};
